import React, {memo, useCallback, useEffect, useRef, useState} from 'react';
import UnderLineImage from '../assets/img/subject_underline_shine_effect.png';
import NetworkMsgImage from '../assets/img/network-message-box.png';
import {conversationRef} from '../config/firebaseConfig';
import {useCollectionData} from 'react-firebase-hooks/firestore';
import {getTimeOfMessage} from './root/helpers';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import {Button} from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';

const styles = theme => ({
	dialogPaper: {
		opacity: '0 !important',
	},
});

function ConversationPage({user, users, onlineUsers}) {
	const [width, setWidth] = useState(window.innerWidth * 0.6);
	const [fontSize, setFontSize] = useState(window.innerWidth > 900 ? 36 : window.innerWidth * 0.02);
	
	const dummyOne = useRef();
	
	const query = conversationRef.orderBy('timestamp', 'asc');
	
	const [messages] = useCollectionData(query);
	
	const [inputValue, setInputValue] = useState('');
	const [openDialog, setOpenDialog] = useState(true);
	const setDialogClose = useCallback(() => setOpenDialog(false), []);
	
	useEffect(() => {
		function handleResize() {
			if (window.innerWidth > 900) {
				setWidth(window.innerWidth * 0.6);
				setFontSize(window.innerWidth * 0.02);
			} else {
				setWidth(window.innerWidth * 0.6);
				setFontSize(window.innerWidth * 0.01);
			}
		}
		
		window.addEventListener('resize', handleResize);
		dummyOne.current.scrollIntoView({behavior: 'smooth'});
	}, [messages]);
	
	
	const sendMessage = async (e) => {
		e.preventDefault();
		if (!inputValue.trim())
			return;
		
		const itemMessage = {
			userId: user.CustID,
			timestamp: Date.now(),
			content: inputValue.trim(),
		};
		
		await conversationRef.add(itemMessage);
		
		setInputValue('');
		
		dummyOne.current.scrollIntoView({behavior: 'smooth'});
	};
	
	const handleKeyDown = (event) => {
		if (event.key === 'Enter') {
			sendMessage(event);
		}
	};
	
	return (
		<div className={'networking-container'} style={{marginTop: '3.1vw'}}>
			<div className={'network-subject'}>
				<h3 style={{fontSize: '1.5vw'}}>Resilience, Recovery & Repositioning Through The Pandemic</h3>
				<img alt={''} width={'100%'} src={UnderLineImage}/>
			</div>
			<div className={'network-chat-area'} style={{
				width: '70%',
				height: width * 0.5,
				display: 'flex',
				backgroundImage: `url(${NetworkMsgImage})`
			}}>
				<div className={'network-chat-message-area'}>
					<div className='network-message-wrapper'>
						{users && messages && messages.map((message, index) => {
								const messageFromUser = users.find(u => u.CustID === message.userId);
								return (
									<div key={index + ''} className={'message-network'}>
										<div style={{
											display: 'inline-flex',
											fontWeight: 900,
											fontSize: '1.1vw',
											alignItems: 'baseline'
										}}>
											{messageFromUser ? messageFromUser.FirstName + ' ' + messageFromUser.LastName : 'unknown user'}
											<div style={{marginLeft: '10px', fontSize: '0.8em', fontWeight: '300'}}>
												{getTimeOfMessage(message.timestamp)}
											</div>
										</div>
										<div className={'message-network-content'}>{message.content}</div>
									</div>);
							}
						)}
						<span ref={dummyOne}/>
					</div>
					<div className={'network-message-input'}>
						<div className="chatInput chatInput-min message-input-area-conv">
							This feature is no longer available
						</div>
					</div>
				</div>
				<div className={'chat-users-area custom-scrollbar'}/>
			</div>
			<Dialog open={openDialog} onClose={setDialogClose}
			        classes={{paper: 'conversation-dialog-paper'}} style={{justifyContent: 'center'}}
			>
				<DialogTitle classes={{root: 'dialog-title-font'}}
				             className='conversation-dialog-title' disableTypography
				>
					This page is no longer available for this on-demand site.
				</DialogTitle>
				<DialogActions style={{justifyContent: 'center'}}>
					<Button onClick={setDialogClose} className='conversation-dialog-button'> Ok </Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}

export default memo(ConversationPage);
